import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import { throwReadableError } from "Utilities/fnReportError";

const getFundList = async () => {
  const endpoint = `/giving/fundList`;

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.get(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const getFunds = async () => {
  const endpoint = `/giving/funds/picker`;

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.get(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const getCampaigns = async () => {
  const endpoint = `/giving/campaignsList`;

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.get(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const getMainSettings = async () => {
  const endpoint = `/Giving/GivePageSettings/Main`;

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.get(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const setMainSettings = async (payload) => {
  const endpoint = `/Giving/GivePageSettings/Main`;

  const fetchFunction = new FnrFetch3(endpoint, payload);
  const response = await fetchFunction.patch(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const getMediaSettings = async () => {
  const endpoint = `/Giving/GivePageSettings/Media`;

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.get(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const setMediaSettings = async (postData) => {
  const endpoint = `/Giving/GivePageSettings/Media`;

  const fetchFunction = new FnrFetch3(endpoint, postData);
  const response = await fetchFunction.post(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const getOtherSettings = async () => {
  const endpoint = `/Giving/GivePageSettings/Other`;

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.get(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const setOtherSettings = async (payload) => {
  const endpoint = `/Giving/GivePageSettings/Other`;

  const fetchFunction = new FnrFetch3(endpoint, payload);
  const response = await fetchFunction.patch(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const getHappiSettings = async () => {
  const endpoint = `/Giving/GivePageSettings/Happes`;

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.get(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const setHappiSettings = async (payload) => {
  const endpoint = `/Giving/GivePageSettings/Happes`;

  const fetchFunction = new FnrFetch3(endpoint, payload);
  const response = await fetchFunction.patch(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const uploadPhoto = async (formData, options) => {
  const endpoint = `/upload/photo/misc`;

  const fetchFunction = new FnrFetch3(endpoint, formData, options);
  const response = await fetchFunction.post(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const getCtas = async () => {
  const endpoint = "/Giving/GivePageSettings/CTA";

  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.get(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const setCta = async (id, payload) => {
  const endpoint = `/Giving/GivePageSettings/CTA${id ? `/${id}` : ""}`;

  const fetchFunction = new FnrFetch3(endpoint, payload);
  const response = await fetchFunction[id ? "patch" : "post"](endpoint).catch(
    (err) => {
      throwReadableError(endpoint, err);
    }
  );

  return response;
};

const deleteCta = async (id, payload) => {
  const endpoint = `/Giving/GivePageSettings/CTA/${id}`;

  const fetchFunction = new FnrFetch3(endpoint, payload);
  const response = await fetchFunction.delete(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

const reorderCtas = async (payload) => {
  const endpoint = `/Giving/GivePageSettings/CTA/Reorder`;

  const fetchFunction = new FnrFetch3(endpoint, payload);
  const response = await fetchFunction.post(endpoint).catch((err) => {
    throwReadableError(endpoint, err);
  });

  return response;
};

export {
  getFundList,
  getFunds,
  getCampaigns,
  getMainSettings,
  setMainSettings,
  getMediaSettings,
  setMediaSettings,
  reorderCtas,
  setCta,
  getCtas,
  deleteCta,
  uploadPhoto,
  getHappiSettings,
  setHappiSettings,
  getOtherSettings,
  setOtherSettings,
};
